import React from 'react';
import { Input } from '../ui/Input';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
import { PartyType, PartyStatus, PartyFilters } from '../../types/party.types';
import { XIcon } from 'lucide-react';
interface PartyFiltersBarProps {
  filters: PartyFilters;
  onFiltersChange: (filters: PartyFilters) => void;
  onClear: () => void;
}
export function PartyFiltersBar({
  filters,
  onFiltersChange,
  onClear
}: PartyFiltersBarProps) {
  const partyTypeOptions = [{
    value: '',
    label: 'All Types'
  }, {
    value: PartyType.CUSTOMER,
    label: 'Customer'
  }, {
    value: PartyType.VENDOR,
    label: 'Vendor'
  }, {
    value: PartyType.EMPLOYEE,
    label: 'Employee'
  }];
  const statusOptions = [{
    value: '',
    label: 'All Status'
  }, {
    value: PartyStatus.ACTIVE,
    label: 'Active'
  }, {
    value: PartyStatus.INACTIVE,
    label: 'Inactive'
  }];
  const mockCategories = [{
    value: '',
    label: 'All Categories'
  }, {
    value: 'cat1',
    label: 'Wholesale'
  }, {
    value: 'cat2',
    label: 'Supplier'
  }, {
    value: 'cat3',
    label: 'Retail'
  }];
  return <div className="bg-white p-4 rounded-lg border space-y-4" data-id="element-179">
      <div className="flex items-center justify-between" data-id="element-180">
        <h3 className="text-sm font-semibold text-gray-900" data-id="element-181">Search Filters</h3>
        <Button variant="secondary" size="sm" onClick={onClear} data-id="element-182">
          <XIcon className="w-4 h-4 mr-1" data-id="element-183" />
          Clear
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-184">
        <Input label="Search" placeholder="Code, Name, Mobile, Email..." value={filters.search || ''} onChange={e => onFiltersChange({
        ...filters,
        search: e.target.value
      })} data-id="element-185" />

        <Select label="Party Type" options={partyTypeOptions} value={filters.partyType || ''} onChange={e => onFiltersChange({
        ...filters,
        partyType: e.target.value as PartyType
      })} data-id="element-186" />

        <Select label="Category" options={mockCategories} value={filters.categoryId || ''} onChange={e => onFiltersChange({
        ...filters,
        categoryId: e.target.value
      })} data-id="element-187" />

        <Select label="Status" options={statusOptions} value={filters.status || ''} onChange={e => onFiltersChange({
        ...filters,
        status: e.target.value as PartyStatus
      })} data-id="element-188" />
      </div>
    </div>;
}